/**
 * Home is also the company directory behind its own flag (and always with the
 * Ask relaunch): /people redirects to it with this router state, so home can
 * tell those visits apart in analytics.
 */
export const HOME_DIRECTORY_STATE = {from: 'people'} as const;

export const isHomeDirectoryOn = ({
  isHomeDirectoryEnabled,
  isAskRelaunchEnabled,
}: {
  isHomeDirectoryEnabled?: boolean;
  isAskRelaunchEnabled?: boolean;
}): boolean => Boolean(isHomeDirectoryEnabled || isAskRelaunchEnabled);

export const isHomeDirectoryVisit = (state: unknown): boolean =>
  typeof state === 'object' &&
  state !== null &&
  (state as {from?: unknown}).from === HOME_DIRECTORY_STATE.from;
